export default "__VITE_ASSET__ChXWjZql__"